import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ModalModule, ModalDirective } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import * as $ from 'jquery';

@Component({
  selector: 'app-new-niche-modal',
  templateUrl: './new-niche-modal.component.html',
  styleUrls: ['./new-niche-modal.component.scss']
})
export class NewNicheModalComponent implements OnInit {
    @ViewChild('newniche', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit() {
    }

    show(): void {
        this.modal.show();
    }

    onShown(): void {
    }

    close(): void {
        this.modal.hide();
    }

}

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
